import { camelCase } from 'lodash';

import { JsonRTEBlockProps } from '~/components/JsonRTEBlock/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { JsonRTEBlock } from './models';

const camelCaseKeys = (obj: Record<string, unknown> | unknown) => {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) return obj.map(camelCaseKeys);

  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [camelCase(k), camelCaseKeys(v)])
  );
};

export const jsonRTEBlockMapper = (
  { pageBlockUI: [pageBlockUI], componentId, rte }: JsonRTEBlock,
  _id,
  { jsonRTEImages }: { jsonRTEImages: JsonRTEBlockProps['rteImages'] }
): JsonRTEBlockProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI.ui),
  componentId,
  rte: camelCaseKeys(rte),
  rteImages: jsonRTEImages,
});
